import {useEffect, useState} from 'react';

import {sortUserFeedback} from 'src/modules/admin/ai-assist-usage/utils/sortUserFeedback';
import {getAllFeedbacksByChangeRequestId} from 'src/openapi/apis/UserFeedbackControllerApi';
import {UserFeedback} from 'src/openapi/models/UserFeedback';
import {useAppDispatch} from 'src/store';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    changeRequestId: number,
};

export const useUserFeedback = ({changeRequestId}: Props) => {
    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();
    const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
    const [userFeedback, setUserFeedback] = useState<UserFeedback[]>([]);

    useEffect(() => {
        setIsFeedbackLoading(true);
        const fetchData = async () => {
            const response = await dispatch(getAllFeedbacksByChangeRequestId({changeRequestId}));

            if (response.payload?.success) {
                setUserFeedback(sortUserFeedback(response.payload.data));
            }

            if (response.payload?.error) {
                onCreateNote({
                    id: 'getAllFeedbacksByChangeRequestIdError',
                    status: Status.ERROR,
                    message: response.payload.data?.message,
                    buttonProps: {iconProps: {type: Icons.CLOSE}},
                    autoHideTimeout: 10000,
                });
            }

            setIsFeedbackLoading(false);
        };

        fetchData();
    }, [changeRequestId, dispatch, onCreateNote]);

    return {userFeedback, isFeedbackLoading};
};
